/* eslint-disable no-unsafe-optional-chaining */
import { DefaultButton, MaskedInput, NewModal, Select } from 'components/index'
import { UserContext } from 'context/userContext'
import { useContext, useState, useRef } from 'react'
import { Icon } from 'assets/index'
import { Form } from '@unform/web'
import { selectOptions } from './factory'
import { Button, Content, FormContainer } from './style'

const Aditivo = () => {
  const { setData, data } = useContext(UserContext)
  const [captations, setCaptations] = useState<any>([])
  const [confirModal, setConfirmModal] = useState(false)
  const [modalFlux, setModalFlux] = useState(false)
  const formRef = useRef<HTMLFormElement | any>(null)

  const handleSetCaption = (e: any) => {
    console.log(e)
  }

  const handleSubmit = () => {
    console.log('kkk')
  }

  return (
    <FormContainer>
      <Form ref={formRef} onSubmit={() => console.log('submit')}>
        <div className="new-token-container">
          <MaskedInput
            smallPad
            type="money"
            handleChange={(e: any) => {
              // console.log(e)
              // const newMinInvest = e
              // const updatedData = {
              //   minInvest: newMinInvest,
              //   maxSupply: newMinInvest / data?.quotaValue,
              // }
              // setData((oldValue: any) => ({
              //   ...oldValue,
              //   ...updatedData,
              // }))
            }}
            placeholder="Valor do investimento"
            name="minInvest"
            defaultValue={data?.minInvest}
          />
        </div>
        <h4 className="detalhes-captacao-subtitle">
          Condições da Rentabilidade
        </h4>
        <div className="new-token-container">
          <Select
            //   uniqKey={`retri_emprend9_${key}`}
            placeholder="Indexador"
            name="paymentType"
            options={selectOptions.paymentType}
            onChange={(e: any) => {
              // setData((oldValue: any) => ({
              //   ...oldValue,
              //   paymentType: e,
              //   indiceId: e?.value === 'PRE' && null,
              // }))
            }}
            value={data?.paymentType}
          />
          <div className="new-token-div-juros">
            <Select
              small
              disabled={data?.paymentType?.value === 'PRE'}
              placeholder="Índice"
              name="indiceId"
              // disabled={data?.paymentType?.value === 'PRE'}
              options={selectOptions.indiceId}
              onChange={(e: any) => {
                // setData((oldValue: any) => ({
                //   ...oldValue,
                //   indiceId: e,
                // }))
              }}
              value={data?.indiceId}
            />
            <span className="new-token-plus">+</span>
            <MaskedInput
              smallPad
              xxsmall
              type="jurosaa"
              handleChange={(e: any) => {
                // setData((oldValue: any) => ({
                //   ...oldValue,
                //   profitability: e,
                // }))
              }}
              placeholder="Juros"
              name="profitability"
              defaultValue={data?.profitability}
            />
            <span className="new-token-plus">% a.a.</span>
          </div>
          <Select
            placeholder="Período de captação"
            name="icoPeriod"
            options={selectOptions.icoDaysPersonal}
            onChange={(e: any) => {
              // setData((oldValue: any) => ({
              //   ...oldValue,
              //   icoPeriod: e,
              // }))
            }}
            value={data?.icoPeriod}
          />
        </div>
      </Form>
      <DefaultButton
        $loading={false}
        onClick={() => setConfirmModal(true)}
        style={{ marginTop: 24 }}
      >
        Continuar
      </DefaultButton>
      <NewModal
        showModal={confirModal}
        height="40%"
        width="60%"
        setShowModal={setConfirmModal}
        noCloseButton
        padding={'30px'}
      >
        <Content>
          <div className="row">
            <p className="big-red-title">Incluir aditivo ao contrato</p>
          </div>
          <p className="black-title">
            Tem certeza que quer realizar esta ação?
          </p>
          <p className="black-content">
            Você está preste a incluir aditivo de contrato de forma definitiva.
          </p>
          <div className="row" style={{ justifyContent: 'space-between' }}>
            <Button onClick={() => setConfirmModal(false)}>
              <img src={Icon('x.svg')} alt="close modal" className="icon" />
              <p>Cancelar</p>
            </Button>
            <div style={{ marginLeft: 40 }}>
              <Button yellow onClick={() => handleSubmit()}>
                <img
                  src={Icon('check.svg')}
                  alt="conf modal"
                  className="icon"
                />
                <p>Confirmar</p>
              </Button>
            </div>
          </div>
        </Content>
      </NewModal>
    </FormContainer>
  )
}

export default Aditivo
